/**
 * @returns {Object}
 */
export function greaterThan() {
    
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {

            ctrl.$validators.greaterThan = (modelValue, viewValue) => {

                modelValue = parseFloat(modelValue);

                const comparedValue = parseFloat(attrs.greaterThan);

                if (!(Number.isFinite(modelValue) && Number.isFinite(comparedValue))) {

                    return true;
                }

                return modelValue > comparedValue;
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/greater-than.directive.js